import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, bannedCustomersActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, bannedCustomersActions);

export default slice.reducer;
